import {
  Scene, Mesh, SphereGeometry, MeshBasicMaterial,
  Vector3, Object3D, Color,
} from 'three';
import { PlayerAircraft } from '../aircraft/PlayerAircraft';
import { IEnemy } from '../enemy/IEnemy';

const BULLET_SPEED = 1200;   // m/s (units/s)
const BULLET_RANGE = 800;    // m
const FIRE_INTERVAL = 1 / 60; // 60発/秒
const POOL_SIZE = 120;
const HIT_RADIUS = 8;        // ヒット判定半径

interface Bullet {
  mesh: Mesh;
  velocity: Vector3;
  life: number;   // 残り寿命(秒)
  active: boolean;
}

export class Vulcan {
  private pool: Bullet[] = [];
  private fireTimer = 0;
  maxAmmo = 500;
  ammo = 500;

  constructor(private scene: Scene, private player: PlayerAircraft) {
    const geo = new SphereGeometry(0.3, 4, 4);
    const mat = new MeshBasicMaterial({ color: new Color(0xffff88) });
    for (let i = 0; i < POOL_SIZE; i++) {
      const mesh = new Mesh(geo, mat);
      mesh.visible = false;
      scene.add(mesh);
      this.pool.push({ mesh, velocity: new Vector3(), life: 0, active: false });
    }
  }

  update(delta: number, firing: boolean): void {
    // 発射処理
    this.fireTimer -= delta;
    if (firing && this.ammo > 0 && this.fireTimer <= 0) {
      this.fireTimer = FIRE_INTERVAL;
      this.ammo--;
      this.spawnBullet();
    }

    // 弾の移動・寿命更新
    for (const b of this.pool) {
      if (!b.active) continue;
      b.mesh.position.addScaledVector(b.velocity, delta);
      b.life -= delta;
      if (b.life <= 0) this.deactivate(b);
    }
  }

  private spawnBullet(): void {
    const b = this.pool.find(b => !b.active);
    if (!b) return;

    // 機首前方に発射
    const forward = new Vector3(0, 0, -1);
    forward.applyQuaternion(this.player.group.quaternion);
    forward.multiplyScalar(BULLET_SPEED);

    b.mesh.position.copy(this.player.position);
    b.mesh.position.addScaledVector(forward.clone().normalize(), 6); // 機首先端から
    b.velocity.copy(forward);
    b.life = BULLET_RANGE / BULLET_SPEED;
    b.active = true;
    b.mesh.visible = true;
  }

  checkHits(enemies: IEnemy[]): { enemy: IEnemy; pos: Vector3 }[] {
    const hits: { enemy: IEnemy; pos: Vector3 }[] = [];
    for (const b of this.pool) {
      if (!b.active) continue;
      for (const enemy of enemies) {
        if (b.mesh.position.distanceTo(enemy.position) < HIT_RADIUS + enemy.hitRadius) {
          hits.push({ enemy, pos: b.mesh.position.clone() });
          this.deactivate(b);
          break;
        }
      }
    }
    return hits;
  }

  private deactivate(b: Bullet): void {
    b.active = false;
    b.mesh.visible = false;
  }

  dispose(): void {
    for (const b of this.pool) {
      b.mesh.geometry.dispose();
      this.scene.remove(b.mesh);
    }
  }
}
